import { useMutation } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../CommonUtils/httpBodyOptions';
import { WizardState } from '../SetGoal/context/SetGoalProvider';
import { wizardToBody } from '../SetGoal/utils/wizardToBody';

interface FetcherParams {
  clientId: string;
  category: string;
  wizard: Partial<WizardState>;
  goalId: string | null;
}

const setGoal = ({ clientId, category, wizard, goalId }: FetcherParams) => {
  const { endpoint, payload } = wizardToBody(wizard);

  return authFetch(endpoint, {
    method: 'POST',
    ...httpBodyOptions(
      { clientId, category, name: wizard.goalDescription, Id: goalId, ...payload },
      true,
    ),
  });
};

export const useSetGoalMutation = () => {
  return useMutation(setGoal);
};
